import { ORDER_STATE } from "./enum";

// 中文名称数组
const ORDER_STATE_LABELS = ['认购中','待接单','待出票','玩家撤销','店主撤销','系统撤销','待开奖','待中奖','未中奖','待派奖','已派奖','已流单'];

// 自动构建映射对象（推荐，减少手动维护成本）
export const ORDER_STATE_MAP = Object.fromEntries(
    Object.entries(ORDER_STATE).map(([key, value]) => {
        // 枚举的value是'0'/'1'...，对应数组的索引
        return [value, ORDER_STATE_LABELS[Number(value)]];
    })
);

/**
 * 撤销人映射对应订单状态
 */
export const REVOKER_MAP: {[k: string]: string} = {
    [ORDER_STATE.PLAYER_REVOKES]: '玩家撤销',
    [ORDER_STATE.SHOP_OWNER_REVOKES]: '店主撤销',
    [ORDER_STATE.SYSTEM_REVOKES]: '系统撤销',
};
